import { useEffect } from 'react';

export function useEffectMounted(callback: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, []);
}
